// eslint-disable-next-line no-useless-escape
export const EMAIL_REG = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,})+$/
export const PASSWORD_REG = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,50}$/
export const PHONE_REG = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/
export const PHONE_NUMBER_REG = /^01([0|1|6|7|8|9])?([0-9]{3,4})?([0-9]{4})$/
